import { render, staticRenderFns } from "./v_Admin_Manage_Tickets.vue?vue&type=template&id=61e4ee20&scoped=true&"
import script from "./v_Admin_Manage_Tickets.vue?vue&type=script&lang=js&"
export * from "./v_Admin_Manage_Tickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e4ee20",
  null
  
)

export default component.exports